import { useQuery } from '@tanstack/react-query';
import { Navigate, createFileRoute, redirect } from '@tanstack/react-router';
import { Card } from '../components/ui/card';
import { api, getToken } from '../lib/api';

interface LinkOption {
  id: string;
  name: string;
  status: string;
}

export const Route = createFileRoute('/audits/')({
  beforeLoad: () => {
    if (!getToken()) throw redirect({ to: '/login' });
  },
  component: AuditsIndexPage,
});

// 「审计记录」入口：不再展示选择落地页，加载链接后默认跳转到第一条链接的审计。
function AuditsIndexPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['links-options'],
    queryFn: () => api<{ rows: LinkOption[] }>('/api/links'),
    staleTime: 60_000,
  });

  if (isLoading) {
    return <div className="text-muted-foreground p-6 text-sm">加载中…</div>;
  }

  const firstId = data?.rows[0]?.id;
  if (!firstId) {
    return (
      <div className="mx-auto max-w-4xl">
        <h1 className="mb-1 text-2xl font-semibold tracking-tight">审计记录</h1>
        <Card className="text-muted-foreground mt-6 p-6 text-center text-sm">
          暂无链接，请先到「链接管理」创建。
        </Card>
      </div>
    );
  }

  return <Navigate to="/audits/$linkId" params={{ linkId: firstId }} replace />;
}
